import React from "react";
import { useAuth } from "../contexts";

function UserInfo({ telegramUser, managerName, role }) {
  return (
    <div className="flex items-center gap-3">
      <div className="text-right">
        <div className="text-sm font-semibold">{managerName}</div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          ID: {telegramUser.id}
        </div>
      </div>
      <div className={`px-3 py-1 rounded-full text-xs font-medium ${
        role === "super_admin"
          ? "bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200"
          : role === "admin" 
          ? "bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200" 
          : "bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200"
      }`}>
        {role === "super_admin" ? "Супер Админ" : role === "admin" ? "Администратор" : "Менеджер"}
      </div>
    </div>
  );
}

export function Topbar({ telegramUser, managerName, role, setView }) {
  return (
    <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div 
            className="cursor-pointer hover:opacity-70 transition-opacity"
            onClick={() => setView && setView("home")}
          >
            <div className="font-semibold">Lead Collector</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">Telegram Mini App</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <UserInfo telegramUser={telegramUser} managerName={managerName} role={role} />
        </div>
      </div>
    </div>
  );
}
